export const BINDING_HEADER = 'x-bazak-guest-auth-binding';

export const SIGN_IN_LINK_TTL_SECONDS = 15 * 60;

/** The shortest government ID the gateway accepts. */
export const MIN_GOVERNMENT_ID_LENGTH = 5;

export const OTP_LENGTH = 6;

export function browserAuthPath({
  tenant,
  action,
}: {
  tenant: string;
  action: 'signin' | 'complete' | 'token' | 'signout' | 'oauth/callback' | 'verify';
}): string {
  return `/api/auth/${encodeURIComponent(tenant)}/${action}`;
}
